const translationJsonObj = require('libs-content-helper').EnTranslations;

var translationJson = {
    "SHARED": {
        "_COMMON_ACROSS_PAGES": {
            "HEADER": {
                "MY_PROFILE": "My profile",
                "LOGOUT": "Log out",
                "SCREEN_READER": {
                    "CAMBRDIGE_LOGO": "Cambridge One Home"
                }
            },
            "FOOTER": {
                "TERMS_OF_USE": "Terms of use",
                "PRIVACY_POLICY": "Privacy notice",
                "ACCESSIBILITY": "Accessibility",
                "OUR_APPROACH": "Our approach",
                "HELP": "Help",
                "CAMBRDIGE_UNIVERSITY_PRESS": "Cambridge University Press & Assessment",
                "INSTITUTION_REQUEST": "Cambridge One for schools",
                "FAQ": "FAQs"
            },
            "COOKIES_BANNER": {
                "WEBSITE_USES_COOKIES": "This website uses cookies. For more information, please visit the ",
                "PRIVACY_POLICY": "Privacy notice",
                "ACCEPT": "Accept cookies"
            }
        },
        "CHANGES_NOT_SAVED": {
            "FORGIVE_US_TEXT": "Sorry …",
            "SORRY_SOMETHING_WRONG_TEXT": "Sorry, something went wrong",
            "SORRY_PROBLEM_AT_OUR_END_TEXT": "Sorry, there's a problem at our end. Please try again later",
            "SOMETHING_WENT_WRONG": "We're unable to submit your work at the moment",
            "LAST_SAVED": "Last saved",
            "PLEASE_TRY_AGAIN": "Please check you're online and try again",
            "OK": "OK",
            "RECORDING_NOT_SAVED": "Sorry, we're unable to save your recording at the moment. Don't worry, you won't lose your work unless you click on the exit button",
            "CHECK_TIPS": "Try the following",
            "FREE_SPACE": "Check you're online",
            "TIPS2": "Free up some space on your device",
            "PLEASE_CHECK_URL_LINK": "Please check the URL added and try again"
        },
        "SAVEALERT": {
            "CLOSE": "Close",
            "EXIT": "Yes, I want to leave",
            "STAY": "Stay on page",
            "LOOSE_WORK_WARNING_MESSAGE": "You will lose your work if you leave now",
            "ARE_YOU_SURE": "Are you sure you want to leave the activity?"
        },
        "COLLAB" : {
            "SHOW_INSTRUCTION": "Show instructions",
            "HIDE_INSTRUCTIONS": "Hide instructions",
            "READY": "Ready",
            "SUBMIT": "Submit",
            "ARE_YOU_READY_TO_SUBMIT": "Ready to submit?",
            "NO_FURTHER_CHANGES_ALLOWED_MESSAGE": "You are acting for all group members. Are you sure that this activity is now complete?",
            "CANCEL": "Cancel",
            "COMPLETE": "Yes, complete",
            "TITLE" : "Collaborative Task",
            "MODAL_PLACEHOLDER" : "This is a collaborative task, where students assigned to a group work together to complete an activity. Students need to be in a group to do this",
            "DISABLE_GROUP_INFO_MSG" : "This is a collaborative activity. It can only be completed by students assigned to groups by a teacher",
            "ARCHIVED_SUBMITTED_LOCK_VERSION_MSG" : "This activity is now locked because the group that worked on it has been archived. You can still see past comments made by the group",
            "ARCHIVED_LOCK_VERSION_MSG" : "The activity is now locked because the group that worked on this has now been archived.",
            "POST_BUTTON" : "Post",
            "NO_COMMENTS_LABEL": "No comments yet",
            "YOUR_COMMENT_LABEL": "Your comment",
            "LOAD_MORE_COMMENTS": "View previous comments",
            "LOADING_COMMENTS": "Loading",
            "ACTOR_TEACHER_LABEL": "Teacher",
            "ELAPSED_TIME": {
                "JUST_NOW": "Just now",
                'MINUTE_AGO': ' minute ago',
                'MINUTES_AGO': ' minutes ago',
                'HOUR_AGO': ' hour ago',
                'HOURS_AGO': ' hours ago',
                'DAY_AGO': ' day ago',
                'DAYS_AGO': ' days ago',
            },
            "SCREEN_READER": {
                "GROUP_INFO": "Group Information",
                "CLOSE_GROUP_INFO": "Close pop-up for Group info",
                "SCROLL_BTN_UP": "Scroll to top",
                "SCROLL_BTN_DOWN": "Scroll to bottom",
                "CROSS": "Close",
                "HELP": "Help"
            }
        },
        "PRODUCT_VIEW": {
            "BACK": "Back",
            "UNIT_STATUS_COMPLETED": "Completed",
            "UNIT_STATUS_IN_PROGRESS": "In progress",
            "SCREEN_READER": {
                "CLOSE_POPUP": "Close popup",
                "LOCKED": "Locked",
                "PROGRESS_BAR": " ,progress bar ",
                "PERCENT": " percent"
            },
            "ASSIGNMENTS_ONLY_BANNER": {
                "DESC": "This material can only be completed by students when you unlock or assign it",
                "DONT_SHOW_AGAIN": "Don't show again",
                "CLOSE": "Close"
            }
        },
        "RESULT_SCREEN": {
            "YOU_SCORED":"You scored",
            "MARKS_OUT_OF":"out of",
            "CONTINUE": "Next activity",
            "REVIEW": "Review answers",
            "TRY_AGAIN": "Try again",
            "START_AGAIN": "Start again"
        },
        "ACTIVITY_RENDERER": {
            "SCREEN_READER": {
                "ACTIVITY": "Activity: {{activityName}}"
            }
        },
        "AUDIO_PROMPT": {
            "FORWARD_BUTTON": "Forward 5 seconds",
            "REWIND_BUTTON": "Rewind 5 seconds",
            "PLAY": "Play",
            "PAUSE": "Pause",
            "SCREEN_READER": {
                "PROGRESS_BAR": "Seek"
            }
        },
        "CONTENT_ACCESS": {
            "RULE": {
                "CONTENT_LOCKED": "Content locked",
                "NO_ACCESS": "You don't have access to this content",
                "NO_ACCESS_ASSIGNMENT_ONLY_PRODUCT": "This content will be available to you when your teacher gives you access",
                "TIME_RANGE_START": "It will be available to you from <strong>{{startDate}} at {{startTime}}</strong>",
                "TIME_RANGE_END": " to <strong>{{endDate}} at {{endTime}}</strong>",
                "GO_BACK": "Go back"
            }
        }
    },
    "HTML_META": {
        "MAIN" : {
            'CUSTOM_TITLE' : ' | Cambridge One',
            "TITLE" : "Cambridge One | Cambridge University Press",
            "DESCRIPTION" : "Cambridge One is a mobile-friendly learning environment for English language learners and teachers."
        }
    },
    "TEACHER": {
        "ACTIVITYVIEW": {
            "_url": ":spaceid/product/:productcode/view/item/:itemid",
            "DOWNLOAD_INSTRUCTIONS1": "Download the",
            "DOWNLOAD_INSTRUCTIONS2": "below and complete this activity",
            "DOWNLOAD": "Download",
            "SUBMITTED_FOR_MARKING": "Submitted",
            "FEEDBACK_READY_MSG": "We'll let you know when your teacher has marked your work",
            "SUBMITTED": "Submitted",
            "ARE_YOU_READY_TO_SUBMIT": "Ready to submit?",
            "ARE_YOU_READY_TO_SUBMIT_GROUP": "Ready to submit your group's work?",
            "NO_FURTHER_CHANGES_ALLOWED_MESSAGE": "Just so you know, it won't be possible to make any changes to your work after it's submitted",
            "NO_FURTHER_CHANGES_ALLOWED_MESSAGE_GROUP": "You are acting for all group members. It won't be possible to change your work later unless your teacher requests it",
            "CANCEL": "Cancel",
            "SUBMIT": "Submit",
            "YES_SUBMIT": "Yes, submit",
            "CLASS_NOT_STARTED_MSG": "Your class hasn't started yet",
            "SAVE_DRAFT_AFTER_CLASS_STARTS": "You can save a draft now and submit to the teacher when your class starts",
            "SAVE": "Save",
            "SAVED": "Saved",
            "AUTO_SAVED": "Auto-saved",
            "COMPLETED": "Completed",
            "START_RECORDING_MSG1": "Tap to start recording",
            "START_RECORDING_MSG2": "You can play it once stopped",
            "PLAY_RECORDING_MSG1": "Play your recording",
            "PLAY_RECORDING_MSG2": "Time recorded: {{elapsedTime}}",
            "STOP_PLAYING_MSG1": "Stop playing",
            "STOP_PLAYING_MSG2": "Time: {{audioSeeker}}/{{duration}}",
            "START_NEW_RECORDING_MSG1": "Start new recording",
            "START_NEW_RECORDING_MSG2": "This will replace the old one",
            "RECORDING": "Recording",
            "STOP_RECORDING_MSG1": "Stop recording",
            "STOP_RECORDING_MSG2": "Time elapsed: {{elapsedTime}}",
            "SEC_LEFT": " sec left",
            "SUBMITTING_MSG1": "Submitting recording ...",
            "SAVING_MSG1": "Saving recording ...",
            "PROCESSING_MSG": "Processing recording ...",
            "SUBMITTED_RECORDING": "Play your recording",
            "RECORDED": "Recorded",
            "FORGIVE_US_TEXT_MSG1": "Sorry ...",
            "RECORDING_NOT_POSSIBLE_MSG1": "We're unable to record your work at the moment",
            "RECORDING_NOT_POSSIBLE_MSG2": "This may be because you're offline, your microphone is not connected, or because your browser does not support recording. Check that you're online and your microphone is on, or try again using a different browser (we suggest Chrome, Firefox or Safari), and/or a different device (tablet or desktop)",
            "OK": "OK",
            "NEXT": "Next",
            "CHECK": "Check",
            "PREVIOUS": "Previous",
            "FIRST_ATTEMPT":"First attempt:",
            "SECOND_ATTEMPT":"Second attempt:",
            "THIRD_ATTEMPT":"Third attempt:",
            "SCORE":"Score :",
            "NO_FEEDBACK": "No feedback",
            "MARKED_AT": "Marked {{elapsedTime}} at {{timestamp}}",
            "MARK" : "Score:",
            "FEEDBACK" : "Feedback:",
            "NEW_SUBMISSION_REQUESTED": "New submission requested",
            "WORDS": "words",
            "WORD_COUNT": "Word count: ",
            "ANSWER": "Answer:",
            "ANSWER_LABEL": "Answer",
            "TITLE" : "Collaborative Task",
            "MODAL_PLACEHOLDER" : "This is a collaborative task, where students assigned to a group work together to complete an activity. Students need to be in a group to do this",
            "DISABLE_GROUP_INFO_MSG" : "This is a collaborative activity. It can only be completed by students assigned to groups by a teacher",
            "ARCHIVED_SUBMITTED_LOCK_VERSION_MSG" : "The activity is now locked because the group that worked on this has now been archived. You can still see the submitted work and the feedbacks from the teacher.",
            "ARCHIVED_LOCK_VERSION_MSG" : "The activity is now locked because the group that worked on this has now been archived.",
            "TYPE_HERE": "Type here ...",
            "NEXT_ACTIVITY": "NEXT ACTIVITY",
            "REVIEW": "REVIEW",
            "BACK": "BACK",
            "ON_BEHALF_OF": "on behalf of",
            "ON_BEHALF_OF_STUDENT_NOT_PRESENT": "A student not in the group submitted on behalf of",
            "GROUP_PSKILL_TITLE": "Title:",
            "ADD_LINK": "Add link",
            "EDIT_LINK": "Edit link",
            "REMOVE_LINK": "Remove link",
            "URL": "URL",
            "URL_PLACEHOLDER": "Enter the destination link",
            "URL_REQUIRED": "URL is required",
            "URL_INVALID": "Enter a valid URL",
            "URL_HELP_TEXT": "(max 256 characters are allowed)",
            "OPTIONAL_TEXT": "Text to display (optional)",
            "OPTIONAL_TEXT_PLACEHOLDER": "Enter the text to display",
            "UPDATE_LINK": "Edit link",
            "ARE_YOU_SURE": "Are you sure?",
            "LINK_WILL_REMOVED": "The link will be removed.",
            "KEEP_LINK": "Keep",
            "CONFIRM_LINK_DELETE": "Yes, delete",
            "PRODUCTIVESKILL_SUBMIT_DISABLE_TOOLTIP": "You will be able to submit this activity when a teacher is added to your class",
            "SCREEN_READER": {
                "CROSS": "Close",
                "HELP": "Help",
                "ACTIVITY_IN_PROGRESS": "Activity status: in progress",
                "SUBMIT_ANSWERS_FOR_MARKING": "Submit",
                "GOTO_NEXT_SCREEN": "Go to next screen",
                "GO_TO_UNIT_VIEW": "Go to unit view",
                "CLOSE_TOC": "Close table of contents",
                "ACTIVITY_COMPLETED_ABOVE_THRESHOLD": "Activity status: completed above target score",
                "ACTIVITY_COMPLETED_BELOW_THRESHOLD": "Activity status: completed below target score",
                "OPEN_TOC": "Open table of contents",
                "DOWNLOADABLE_ITEM": "Downloadable item",
                "BOLD": "Bold",
                "ITALIC": "Italic",
                "UNDERLINE": "Underline",
                "OPEN_LINK": "Open link: ",
                "SHOW_LINK_OPTIONS": "Show link options",
                "CANCEL_DELETE_LINK": "Cancel link deletion",
                "ACTIVITY_SCREEN_STATUS": "Exercise {{currentScreen}} of {{totalScreens}}"
            }
        },
        "GROUPSELECTON": {
          "SELECT_GROUP" : "Select group",
          "NO_GROUP" : "No Groups Found",
          "ARCHIVED_GROUPS": "Archived groups",
          "GROUP_SORT_OLDEST_FIRST": "Date (Oldest first)",
          "GROUP_SORT_NEWEST_FIRST": "Date (Newest first)",
          "GROUP_SORT_BY": "Sort by:"
        },
        "PRODUCT_VIEW": {
            "BANNER_MESSAGE": "{{activatedProductTitles}} for {{bundleTitle}} activated",
            "PEAS_BANNER_MESSAGE": "{{peasBundleTitle}} activated"
        }
    },
    "LEARNER": {
        "CREATE_USER_ANALYTICS": {
            "WELCOME_TEXT": "Welcome to your Cambridge One",
            "DESCRIPTION_TEXT": "We’re setting up the learning materials for you",
        },
    }
}
module.exports = Object.assign(translationJsonObj, translationJson);
